"use strict";
exports.__esModule = true;
exports.useWindowDimensions = void 0;
var react_1 = require("react");
var useWindowDimensions = function () {
    var getWindowDimensions = function () {
        var width = window.innerWidth, height = window.innerHeight;
        return {
            width: width,
            height: height
        };
    };
    var _a = (0, react_1.useState)(getWindowDimensions()), windowDimensions = _a[0], setWindowDimensions = _a[1];
    (0, react_1.useEffect)(function () {
        var onResize = function () {
            setWindowDimensions(getWindowDimensions());
        };
        window.addEventListener('resize', onResize);
        return function () { return window.removeEventListener('resize', onResize); };
    }, []);
    return windowDimensions;
};
exports.useWindowDimensions = useWindowDimensions;
